import React, { Component, Fragment } from "react";
import CircularLoadingScreen from "../../commons/CircularLoadingScreen";
import postService from "../../../services/postService";
import PostList from "../PostList";
import { withSnackbar } from "./../../../hocs/withSnackbar";

class ProfilePosts extends Component {
  state = { loaded: false, posts: [] };

  async componentDidMount() {
    await this.loadUserPosts();
  }

  loadUserPosts = async (rateLimit = true) => {
    const load = async () => {
      const username = this.props.match.params.name;
      const response = await postService.getUserPosts(username);
      const userPosts = response.data.data;
      this.setState({ loaded: true, posts: userPosts });
    };

    if (rateLimit) {
      setTimeout(load, 500);
    } else {
      load();
    }
  };

  render() {
    const { loaded, posts } = this.state;
    return (
      <Fragment>
        {!loaded ? (
          <CircularLoadingScreen thickness={5} />
        ) : (
          <PostList
            posts={posts}
            noPostsError="This user has no posts"
            onDelete={() => {
              this.props.showMessage("Deleted post");
              this.loadUserPosts(false);
            }}
          />
        )}
      </Fragment>
    );
  }
}

export default withSnackbar(ProfilePosts);
